export default __webpack_public_path__ + "static/media/envelope.2ea3b25b.svg";